import { FormGroup } from "reactstrap";
import { useEffect, useRef, useState } from "react";
import { Button } from "reactstrap";
import { Typeahead } from "react-bootstrap-typeahead";

const FilterAssignments = ({
  input,
  label,
  options,
  disabled,
  teamMemberData,
  values,
  placeholder,
  onClear,
  setOnClear
}: any) => {
  const [selected, setSelected] = useState("");

  const onChangeValues = (event: any) => {
    event.preventDefault();
    if (event.target.value) {
      setSelected(event.target.value);
      return input.onChange([event.target.value]);
    } else {
      return input.onChange([]);
    }
  };
  useEffect(() => {
    setSelected(input.value);
  }, [input.value]);

  const typeaheadRef = useRef<any>(null);
  useEffect(()=>{
    if(setOnClear){
      setOnClear(false)
      typeaheadRef.current.clear();
    }
  },[onClear])
  const getValues = (values: any) => {
    if (values.length > 0) {
      return input.onChange(values);
    } else {
      return input.onChange([]);
    }
  };

  return (
    <div className="filterAssignmentsWrapper">
      <FormGroup className="mb-4">
        <label>{label}</label>
        <div className="d-flex bizOptions">
          {options?.map((element: any) => (
            <Button
              key={input.name}
              disabled={disabled}
               type="button"
              name={input.name}
              className={`${
                element.value == selected ? "optSelected" : "optionBox"
              }`}
              value={element.value}
              onClick={(event: any) => onChangeValues(event)}
            >
              {element.text}
            </Button>
          ))}
        </div>
        <div className="selectTeamMemberDiv">
          <Typeahead
            id="basic-typeahead-multiple"
            className="multiSelectField"
            labelKey="text"
            multiple
            placeholder={placeholder}
            onChange={(event: any) => {
              getValues(event);
            }}
            options={teamMemberData}
            selected={
              selected == ""
                ? !input?.value?.includes("0")
                  ? input?.value
                  : null
                : null
            }
            ref={typeaheadRef}
          />
        </div>
      </FormGroup>
    </div>
  );
};

export default FilterAssignments;
